import { createGlobalStyle, css } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: #f8f8f8;
    color: #000;
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      body {
        background-color: #161b21;
        color: #f0f0f0;
      }
    `}

  body.col-resizing,
  body.col-resizing * {
    cursor: col-resize !important;
    user-select: none !important;
  }
`;
